module.exports = __webpack_public_path__ + "static/media/ngo2.6dd9a7eb.jpg";